import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white py-12 border-t border-gray-900" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-52">
          <div className="mb-6 md:mb-0" data-id="element-53">
            
          </div>
          <div className="text-gray-500 text-sm text-center md:text-right" data-id="element-54">
            <p data-id="element-55">
              &copy; {new Date().getFullYear()} Mente de Rica. Todos los
              derechos reservados.
            </p>
            <div className="mt-2 space-x-4" data-id="element-56">
              <a href="#" className="hover:text-white transition-colors" data-id="element-57">
                Términos y Condiciones
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-58">
                Política de Privacidad
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}